<template>
    <a-modal  title="申诉" :visible="visible" :confirm-loading="confirmLoading" cancelText="取消" okText="确定" @ok="handleOk" @cancel="handleCancel">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item ref="contactName" label="联系人" prop="contactName">
               <a-input  v-model="form.contactName" aria-placeholder="联系人"></a-input>
            </a-form-model-item> 
            <a-form-model-item ref="contactPhone" label="联系方式" prop="contactPhone">
               <a-input  v-model="form.contactPhone" placeholder="联系方式"></a-input>
            </a-form-model-item> 
            <a-form-model-item ref="complaintReason" label="申诉原因" prop="complaintReason">
               <a-input  v-model="form.complaintReason" type="textarea" placeholder="申诉原因"></a-input>
            </a-form-model-item> 
        </a-form-model>             
    </a-modal>
</template>

<script>
export default {
    data(){
        return{
            visible:false,
            confirmLoading:false,
            currentItem:'',
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
            other: '',
            form: {
                orderNo:'',
                contactName: '',
                contactPhone:'',
                complaintReason:'',
                complaintType:'',//申诉类型(0挂牌 1竞价)
                complaintObj:'',//申诉对象(0 买家 1卖家)

            },
            rules: {
                contactName: [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
                ],
                contactPhone:[
                    { required: true, message: '请输入联系人电话', trigger: 'blur' },
                    {
                        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                        message: '请输入正确的手机号',
                        trigger: "blur", 
                    }
                ],
                complaintReason:[
                    { required: true, message: '请输入原因', trigger: 'blur' },
                ]
            }
        }
    },
    methods:{
        showDialog(record,complaintType,complaintObj){
            this.currentItem = JSON.parse(record);
            this.form.orderNo = this.currentItem.orderNo;
            this.form.complaintType = complaintType;
            this.form.complaintObj = complaintObj;
            this.visible = true;
        },
        handleOk(){
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.$https.post('/portal/complaint/add',this.form).then(res=>{
                        if(res.code == 200){
                            this.visible = false;
                            this.$emit('setlist');
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleCancel(){
            this.visible = false;
        }
    }
}
</script>

<style>

</style>